class TC_SystemMessages {
    constructor () {
        if ($('#system-message-container').length) {
            this.initEvents();
        }
    }

    initEvents () {
        let messsagesContainer = $('#system-message-container');
        let messages = $('#system-message-container .alert');
        let alertPopup = $('.alert-popup', messsagesContainer);

        messages.each((i, message) => {
            message = $(message);

            message.find('.close').on('click', (e) => {
                e.preventDefault();
                message.remove();
            });
        });

        if (alertPopup.length){
            messsagesContainer.addClass('system-message-popup');

            alertPopup.on('click', '[data-action="request-new-token"]', () => {
                $('.mod-calmradio-login:first-of-type').addClass('is-hidden');
                $('.password-reminder').removeClass('is-hidden');
            });
        }

        messsagesContainer.click(function () {
            $(this).remove();
        });
    }
}